import DOMPurify from 'dompurify';

export function stripTags(string) {
  return DOMPurify.sanitize(string, { ALLOWED_TAGS: ['b', 'i'] });
}
